import { useState, useEffect } from "react";

import { Preloader } from "../PagePreloader";

export function PreloaderLayout({ children }: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleLoadComplete = () => {
      setTimeout(() => setIsLoading(false), 1000);
    };

    if (document.readyState === "complete") {
      handleLoadComplete();
    } else {
      window.addEventListener("load", handleLoadComplete);
      return () => window.removeEventListener("load", handleLoadComplete);
    }
  }, []);

  return (
    <>
      <Preloader isLoading={isLoading} />
      <div
        style={{
          opacity: isLoading ? 0 : 1,
          transition: "ease-in-out",
        }}
      >
        {children}
      </div>
    </>
  );
}
